/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * Component: `.accordion-block`
 * This expands / collapses all accordions
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

_.each(document.querySelectorAll('.accordion-block'), $accordionBlock => {

	const $expandAll = $accordionBlock.querySelector('.expand-all')
	const $collapseAll = $accordionBlock.querySelector('.collapse-all')
	const $$toggles = $accordionBlock.querySelectorAll('.accordion-title')

	if ($expandAll && $collapseAll) {

		_.each($$toggles, $toggle => {
			$toggle.addEventListener('click', function() {
				const expanded = $toggle.getAttribute('aria-expanded') === 'true'
				if (expanded) {
					$collapseAll.removeAttribute('aria-expanded')
					$collapseAll.disabled = false
					if (_.map($$toggles, $toggle => $toggle.getAttribute('aria-expanded')).indexOf('false') < 0) {
						$expandAll.setAttribute('aria-expanded', 'true')
						$expandAll.disabled = true
					}
				} else {
					$expandAll.removeAttribute('aria-expanded')
					$expandAll.disabled = false
					if (_.map($$toggles, $toggle => $toggle.getAttribute('aria-expanded')).indexOf('true') < 0) {
						$collapseAll.setAttribute('aria-expanded', 'false')
						$collapseAll.disabled = true
					}
				}
			})
			$toggle.addEventListener('keydown', function() {
				if (event.keyCode === 13 || event.keyCode === 32) {
					const expanded = $toggle.getAttribute('aria-expanded') === 'true'
					if (expanded) {
						$collapseAll.removeAttribute('aria-expanded')
						$collapseAll.disabled = false
						if (_.map($$toggles, $toggle => $toggle.getAttribute('aria-expanded')).indexOf('false') < 0) {
							$expandAll.setAttribute('aria-expanded', 'true')
							$expandAll.disabled = true
						}
					} else {
						$expandAll.removeAttribute('aria-expanded')
						$expandAll.disabled = false
						if (_.map($$toggles, $toggle => $toggle.getAttribute('aria-expanded')).indexOf('true') < 0) {
							$collapseAll.setAttribute('aria-expanded', 'false')
							$collapseAll.disabled = true
						}
					}
				}
			})
		})

		$expandAll.addEventListener('click', function() {
			$expandAll.setAttribute('aria-expanded', 'true')
			$expandAll.disabled = true
			$collapseAll.removeAttribute('aria-expanded')
			$collapseAll.disabled = false
			_.each($$toggles, $toggle => {
				if ($toggle.getAttribute('aria-expanded') === 'false') {
					$($toggle).click()
				}
			})
		})

		$collapseAll.addEventListener('click', function() {
			$collapseAll.setAttribute('aria-expanded', 'false')
			$collapseAll.disabled = true
			$expandAll.removeAttribute('aria-expanded')
			$expandAll.disabled = false
			_.each($$toggles, $toggle => {
				if ($toggle.getAttribute('aria-expanded') === 'true') {
					$($toggle).click()
				}
			})
		})
	}

	// jump to the top of any given accordion
	_.each($accordionBlock.querySelectorAll('.back-to-top'), $backToTop => {
		$backToTop.addEventListener('click', event => {
			event.preventDefault()
			window.scroll(0, $accordionBlock.getBoundingClientRect().top + window.pageYOffset - 125)
		})
	})
})
